import { useGetAffectationCountQuery } from '@/features/api/endpoints/affectationEndpoints';
import { Badge, Menu } from '@mantine/core';
import { IconUserShield } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';
import { useNavigate } from 'react-router-dom';

const AdminAffectationsMenuItem = () => {
  const { t } = useTranslate();
  const navigate = useNavigate();

  const { data: draftCount } = useGetAffectationCountQuery({
    filter: {
      status: { _eq: 'draft' },
    },
  });

  return (
    <Menu.Item
      leftSection={<IconUserShield stroke={1.5} />}
      rightSection={
        draftCount != null && draftCount > 0 ? (
          <Badge size="xs" variant="filled" circle color="yellow">
            {draftCount}
          </Badge>
        ) : undefined
      }
      onClick={() => navigate('/admin/affectations')}
    >
      {t('nav.admin.affectations')}
    </Menu.Item>
  );
};

export default AdminAffectationsMenuItem;
